export default "__VITE_PUBLIC_ASSET__e5467e58__"